// @flow
import * as React from "react"
import {
  compose,
  withHandlers,
  branch,
  renderNothing,
  type HOC,
} from "recompose"
import { path } from "ramda"
import featureFlags from "global/feature-flags"
import withUser from "hoc/withUser"
import withConnect from "hoc/withConnect"
import ArrowIcon from "assets/icons/ArrowIcon"
import Mobile from "components/Media/Mobile"
import Desktop from "components/Media/Desktop"
import { Text } from "componentsStyled/Typography/Texts"
import { openModal } from "data/modals/actions"
import type { Plan } from "data/plans/types"
import SignUpModal from "modals/SignUp"
import SubscribePlan from "modals/SubscribePlan"
import PassportPlanIcon from "assets/icons/PlanIcon"
import PerksPlanIcon from "components/PlanIcon"
import { PlanLinkWrapper, IconTile, Body, ArrowWrap, Arrow, StyledOffset as Offset } from "./styled"

type Props = {
  plan: Plan,
  description?: string,
}

const PlanBanner = ({ handleOpenModal, plan, description = "Experience total freedom." }) => {
  const showPassportUpsellInProductsPage = featureFlags.showPassportUpsellInProductsPage()

  return (
    <Offset>
      <PlanLinkWrapper onClick={handleOpenModal}>
        <IconTile>
          {
            showPassportUpsellInProductsPage
              ? <PassportPlanIcon planTitle={plan.title} />
              : <PerksPlanIcon planTitle={plan.title} />
          }
        </IconTile>
        <Body>
          <Text lh={2}>
            <Desktop>
              <Text black book inline lh={2}>
                Subscribe to Awayco {plan.title}
              </Text>{" "}
            </Desktop>
            <Mobile>
              <Text black book lh={2}>
                Subscribe to Awayco {plan.title}
              </Text>
            </Mobile>
            and get 25% off bookings
          </Text>
        </Body>
        <ArrowWrap>
          <Arrow>
            <ArrowIcon rotation="right" color="white" />
          </Arrow>
        </ArrowWrap>
      </PlanLinkWrapper>
    </Offset>
  )
}

const openSubscribeModal = (props) => {
  props.openModal(SubscribePlan, {
    plan: props.plan,
    details: true
  })
}

const enhancer: HOC<*, Props> = compose(
  withUser(),
  branch(props =>
    path(["user", "subscription", "plan", "type", "slug"], props) === props.plan.slug,
    renderNothing,
  ),
  withConnect(() => ({}), { openModal }),
  withHandlers({
    handleOpenModal: props => () => {
      if (!props.user) {
        props.openModal(SignUpModal, {
          callback: () => openSubscribeModal(props)
        })
      } else {
        openSubscribeModal(props)
      }
    }
  }),
)

export default enhancer(PlanBanner)



// WEBPACK FOOTER //
// ./src/components/PlanBanner/index.js